<template>
  <div class="footer">
    <div 
      :class="'item' + ($route.name == item.routerName ? ' item-cur': '')"
      v-for="item in navList"
      :key="item.routeName"
      @click="tapNav(item)"
    >
      <div class="icon">
        <van-icon :name="item.icon" />

      </div>
      <div class="title">{{ item.title }}</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState(['user']),
    navList() {
      if (this.user) {
        if (this.user.member_type == 3) {
          return [
            {
              routerName: 'DisChart',
              icon: 'bar-chart-o',
              title: '数据'
            },
            {
              routerName: 'DisGM',
              icon: 'friends-o',
              title: '团队'
            },
            {
              routerName: 'DisStudy',
              icon: 'bulb-o',
              title: '学习'
            },
            {
              routerName: 'DisIndex',
              icon: 'user-circle-o',
              title: '我的'
            },
          ]
        } else if (this.user.member_type == 2) {

          return [
            {
              routerName: 'GMChart',
              icon: 'bar-chart-o',
              title: '数据'
            },
            {
              routerName: 'GMCustomer',
              icon: 'friends-o',
              title: '会员'
            },
            {
              routerName: 'GMStudy',
              icon: 'bulb-o',
              title: '学习'
            },
            {
              routerName: 'GMLive',
              icon: 'tv-o',
              title: '直播'
            }
          ]
        }
      }
      return []
    }
  },
  methods: {
    tapNav(nav) {
      this.$router.push({
        name: nav.routerName
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer {
    z-index: 999;
    position: fixed;
    display: flex;
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100vw;
    border-top: 1px solid #ccc;
    background: #fefefe;
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      text-align: center;
      color: #444;
      .icon {
        font-size: 24px;
      }
      &.item-cur {
        color: #07c160;
      }
    }
  }
</style>